import {
  ADD_CRITERIA,
  APPLY_FILTER,
  CHANGE_LOADING,
  CHANGE_MODE,
  CHANGE_SIMPLE_SEARCH,
  CHANGE_TABLE_LOADING,
  CLEAR_PARAMS,
  CREATE_OBJECT_OF_ID,
  PARSE_DATA,
  REMOVE_CRITERIA,
  REMOVE_HISTORICAL_DATE,
  RESET_CRITERIA,
  RESET_SIMPLE_FILTERS,
  SELECT_ROW,
  SET_ALL,
  SET_CRITERIA,
  SET_FILTERS,
  SET_FULLTEXT_FILTER,
  SET_HEIGHT_OF_TBODY,
  SET_HISTORICAL_DATE,
  SET_PAGE_NUMBER,
  SET_PER_PAGE,
  SET_SORTING_BY,
  SHOW_RESULTS,
  SHOW_SEARCH_ERROR,
  TOGGLE_EXPORT_MODAL,
  SET_EXPORT_FORMAT,
  GOLDEN_COPY_PUBLISH_DATE,
} from './mutations-types'
import { findFilterById, parseCriteriaFromUrl, templateCriteria, } from './helpers'
import { parseDate, } from '../../helpers'

export default {
  [CHANGE_MODE] (state, value) {
    state.expertMode = !value
  },
  [CHANGE_LOADING] (state, show) {
    state.loading = show
  },
  [SET_SORTING_BY] (state, field) {
    state.sortedBy = {
      desc: state.sortedBy.field === field ? !state.sortedBy.desc : false,
      field,
    }
  },
  [SET_HEIGHT_OF_TBODY] (state, height) {
    state.heightOfTableBody = height
  },
  [CHANGE_TABLE_LOADING] (state, show) {
    state.tableLoading = show
  },
  [PARSE_DATA] (state, {
    data,
    meta: { pagination: { perPage, currentPage, total, lastPage, }, goldenCopy: { publishDate, }, },
  }) {
    state.publishDate = `${parseDate(publishDate, 'YYYYMMDD')}-0000`
    state.goldenCopyPublishDate = publishDate
    state.items = parseResults(data)
    state.total = total
    state.currentPage = currentPage
    state.perPage = perPage
    state.lastPage = lastPage
  },
  [CREATE_OBJECT_OF_ID] (state, arr) {
    state.checkedItems = arr.reduce((acc, { id, }) => ({
      ...acc,
      [id]: false,
    }), {})
  },
  [SELECT_ROW] (state, { id, checked, }) {
    state.checkedItems[id] = checked
  },
  [REMOVE_HISTORICAL_DATE] (state) {
    state.historicalDate = {
      dateOne: '',
      dateTwo: '',
    }
  },
  [SET_HISTORICAL_DATE] (state, { index, date, }) {
    console.log(index, date, state.historicalDate)
    state.historicalDate[index] = date
  },
  [ADD_CRITERIA] (state) {
    state.criteria.push(templateCriteria())
  },
  [REMOVE_CRITERIA] (state, index) {
    state.criteria.splice(index, 1)
  },
  [SET_CRITERIA] (state, { index, criteria, }) {
    state.criteria[index] = Object.assign(state.criteria[index], criteria)
  },
  [RESET_CRITERIA] (state) {
    state.criteria = [ templateCriteria(findFilterById(state.filters, 'LEIREC_LEGAL_NAME')), ]
  },
  [CHANGE_SIMPLE_SEARCH] (state, value) {
    state.simpleSearch = value
  },
  [SHOW_RESULTS] (state, show) {
    state.showResults = show
  },
  [SHOW_SEARCH_ERROR] (state, error) {
    state.searchError = error
  },
  [SET_PER_PAGE] (state, value) {
    state.perPage = value
  },
  [SET_PAGE_NUMBER] (state, value) {
    state.currentPage = value
  },
  [SET_FILTERS] (state, data) {
    state.filters = data.map(({ attributes, id, }) => ({
      ...attributes,
      id,
      value: null,
    }))
  },
  [SET_FULLTEXT_FILTER] (state, filter) {
    state.fulltextFilter = filter
  },
  [APPLY_FILTER] (state, { filter, value, }) {
    state.filters.find((f) => f === filter).value = value
    state.simpleFilters = Object.assign({}, state.simpleFilters, { [filter.field]: value, })
  },
  [SET_ALL] (state, {
    fulltextFilterId, simpleFilters, simpleSearch,
    sortedBy, currentPage, perPage, criteria, expertMode,
  }) {
    state.expertMode = expertMode === 'true'
    state.fulltextFilter = findFilterById(state.filters, fulltextFilterId || 'LEIREC_FULLTEXT')
    state.simpleSearch = simpleSearch || ''
    state.currentPage = currentPage || null
    state.perPage = perPage || null
    state.simpleFilters = simpleFilters || null
    Object.getOwnPropertyNames(simpleFilters || {}).forEach((key) => {
      const appliedFilter = state.filters.find((f) => f.field === key)
      if (appliedFilter) appliedFilter.value = simpleFilters[key]
    })
    if (sortedBy) {
      state.sortedBy.desc = sortedBy.desc === 'true'
      state.sortedBy.field = sortedBy.field
    }
    if (criteria) {
      state.criteria = parseCriteriaFromUrl(state, criteria)
    }
  },
  [RESET_SIMPLE_FILTERS] (state) {
    state.simpleFilters = null
    state.filters = state.filters.map((f) => ({
      ...f,
      value: '',
    }))
    state.simpleSearch = ''
    state.fulltextFilter = findFilterById(state.filters, 'LEIREC_FULLTEXT')
  },
  [CLEAR_PARAMS] (state) {
    state.simpleFilters = null
    state.filters = state.filters.map((f) => ({
      ...f,
      value: '',
    }))
    state.currentPage = null
    state.perPage = null
    state.sortedBy = {
      desc: false,
      field: null,
    }
    state.simpleSearch = ''
    state.fulltextFilter = findFilterById(state.filters, 'LEIREC_FULLTEXT')
  },
  [TOGGLE_EXPORT_MODAL] (state, value) {
    state.showExportModal = value
  },
  [SET_EXPORT_FORMAT] (state, value) {
    state.exportFormat = value
  },
  [GOLDEN_COPY_PUBLISH_DATE] (state, value) {
    state.goldenCopyPublishDate = value
  },
}

const parseResults = (data) => data.map(({ attributes, id, relationship, type, }) => ({
  ...attributes,
  id,
  relationship,
  type,
}))



// WEBPACK FOOTER //
// ./src/store/modules/search/mutations.js